import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { copy } from "@wheels-crm/shared-types";
import { useReminders } from "../hooks/useReminders";
import { Button } from "../components/ui/Button";
import { ReminderBadge } from "../components/orders/ReminderBadge";

type Tab = "active" | "done" | "all";

export function RemindersPage() {
  const { reminders, loading, markDone } = useReminders();
  const [tab, setTab] = useState<Tab>("active");

  const filtered = useMemo(() => {
    if (tab === "active") return reminders.filter((r) => !r.is_done);
    if (tab === "done") return reminders.filter((r) => r.is_done);
    return reminders;
  }, [reminders, tab]);

  return (
    <div>
      <div className="page-header">
        <h1>{copy.nav.reminders}</h1>
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        <Button variant={tab === "active" ? "primary" : "default"} onClick={() => setTab("active")}>
          {copy.reminders.tabActive}
        </Button>
        <Button variant={tab === "done" ? "primary" : "default"} onClick={() => setTab("done")}>
          {copy.reminders.tabDone}
        </Button>
        <Button variant={tab === "all" ? "primary" : "default"} onClick={() => setTab("all")}>
          {copy.reminders.tabAll}
        </Button>
      </div>

      {loading ? (
        <p>Завантаження…</p>
      ) : filtered.length === 0 ? (
        <p className="empty-state">{copy.emptyState}</p>
      ) : (
        <div className="card">
          {filtered.map((r) => (
            <div
              key={r.id}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 8,
                padding: "8px 0",
                borderBottom: "1px solid var(--color-border)",
                opacity: r.is_done ? 0.5 : 1,
              }}
            >
              <div>
                <Link to={`/orders/${r.order_id}`}>{r.order.client.name}</Link>
                {" — "}
                {!r.is_done ? <ReminderBadge reminder={r} /> : <span>{r.note}</span>}
                {!r.is_done && <span style={{ fontSize: 13 }}> {r.note}</span>}
              </div>
              {!r.is_done && <Button onClick={() => markDone(r.id)}>{copy.reminders.markDone}</Button>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
